export const META_PIXEL_ID = '1059200950343802'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const CONTENT = {
  content_name: 'Yoga Teacher System™',
  content_category: 'Digital Product',
  content_ids: ['yoga-teacher-system'],
  content_type: 'product',
  value: 19,
  currency: 'USD',
}

let initialized = false
let scriptLoaded = false
let pageViewSent = false

/** Loads fbevents.js. The fbq stub queues any events fired before it finishes. */
function loadPixelScript(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  if (!window.fbq) {
    const fbq: any = function (...args: unknown[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args)
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    window._fbq = fbq
  }

  if (document.getElementById('meta-pixel-script')) return

  const script = document.createElement('script')
  script.id = 'meta-pixel-script'
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  script.onload = () => {
    scriptLoaded = true
  }
  document.head.appendChild(script)
}

/**
 * Fallback for when fbevents.js is blocked (ad blockers, sandboxed previews):
 * fires the event straight to Meta's tracking endpoint with an image request.
 */
function imageFallback(event: string): void {
  if (typeof document === 'undefined') return
  const img = new Image(1, 1)
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=${encodeURIComponent(
    event,
  )}&noscript=1&rnd=${Date.now()}`
  document.body.appendChild(img)
}

export function track(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return

  loadPixelScript()

  if (!initialized) {
    window.fbq('init', META_PIXEL_ID)
    initialized = true
  }

  window.fbq('track', event, params)

  // If the library never loads, make sure the event still reaches Meta.
  window.setTimeout(() => {
    if (!scriptLoaded && !window.fbq?.callMethod) imageFallback(event)
  }, 2500)
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || pageViewSent) return
  pageViewSent = true

  loadPixelScript()

  if (!initialized) {
    window.fbq('init', META_PIXEL_ID)
    initialized = true
  }

  window.fbq('track', 'PageView')
  window.fbq('track', 'ViewContent', CONTENT)

  window.setTimeout(() => {
    if (!scriptLoaded && !window.fbq?.callMethod) {
      imageFallback('PageView')
      imageFallback('ViewContent')
    }
  }, 2500)
}

let checkoutSent = false

export function trackInitiateCheckout(): void {
  if (typeof window === 'undefined' || checkoutSent) return
  checkoutSent = true

  track('InitiateCheckout', { ...CONTENT, num_items: 1 })

  // The visitor is leaving for the checkout: send a direct beacon right away
  // so the event lands even if fbevents.js hasn't finished loading or is blocked.
  if (!window.fbq?.callMethod) imageFallback('InitiateCheckout')

  // Allow the event again if the visitor comes back and clicks a second time.
  window.setTimeout(() => {
    checkoutSent = false
  }, 5000)
}
